export enum ExperienceEnum {
    EMAIL_EXPERIENCE = 'emailExperience',
    LIVE_CHAT_EXPERIENCE = 'livechatExperience',
    SPEED_EXPERIENCE = 'speedExperience',
    WITHDRAWAL_EXPERIENCE = 'withdrawalExperience',
}

export type ExperienceKey = keyof typeof ExperienceEnum;
export type ExperienceValues = typeof ExperienceEnum[keyof typeof ExperienceEnum];